// extracted by mini-css-extract-plugin
export default {"brandPromo":"AF-z","carousel":"BF-z"};